// extracted by mini-css-extract-plugin
module.exports = {"SetOfCircleIcons":"SetOfCircleIcons-module__SetOfCircleIcons___2QWQZ"};